'use strict';

require('../../style/index.less');

require('./index.less');

require('../../checkbox/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/tree/style/index.js
 ** module id = 249
 ** module chunks = 0
 **/